export const LocalFeatureFlags = {
  ai_assistant: true,
  catalog: false,
  lifestyle_image: true,
  local_settings: true,
  mip_maps_gaussian_blur: true,
  org_management: true,
  product_2d: true,
  textura_viewer_setup: false,
  use_stitches_decals: true,
  brand_logos: false,
};
